import useAnalytics from '../../hooks/useAnalytics';
import Footer from './Footer';

interface MyPolicyFooterProps {
  customerHasUbiPolicy?: boolean;
}

const MyPolicyFooter = ({
  customerHasUbiPolicy = false,
}: MyPolicyFooterProps) => {
  const { track } = useAnalytics();

  return <Footer customerHasUbiPolicy={customerHasUbiPolicy} track={track} />;
};

export default MyPolicyFooter;
